module.exports = __webpack_public_path__ + "img/删除 (13).3e294eef.png";